<template>
  <div class="page-btns-father">
    <div class="page-btns-main">
      <div class="common-title">发票上传</div>
      <div class="page-main common no-shadow common-form-inline">
        <a-form-model ref="ruleForm" :model="pageData" :label-col="{ span: 6 }" :wrapper-col="{ span: 13 }">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="卖方名称">
                <div style="white-space: nowrap;">
                  <span>{{ pageData.sellrName }}</span>
                  <span style="margin-left:16px;">
                    {{
                      pageData.sellrOrgCode
                    }}
                  </span>
                </div>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item label="发票上传">
                <invoiceUpload style="height:60px;" :file="fileList" :paramObj="uploadParam" @uploadOk="uploadOk"
                  name="file" :pageData="pageData"></invoiceUpload>
                <div class="text-color-orange img-tip">温馨提示：每次上传最多不可超过10张,单张发票不可超过4M。</div>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <div class="common-title">发票列表</div>
      <div class="table-common common">
        <a-table size="middle" :columns="columns" :data-source="tableData" :rowKey="(record, index) => { return index }"
          :loading="loading" bordered :locale="{ emptyText: '暂无数据' }" :pagination="false">
          <template slot="fileNm" slot-scope="text, record">{{ (record.file && record.file.fileNm) || (record.file &&
            record.file.name) }}</template>
          <template slot="fileRte" slot-scope="text, record">
            <!-- {{record.file && record.file.fileRte}} -->
            <img :src="getImgUrl(record.file)" alt srcset width="40" @click="preview(record.file)" />
          </template>
          <template slot="errmsg" slot-scope="text, record">{{ (record.file && record.file.errmsg) || "成功" }}</template>
          <template slot="invoiceType" slot-scope="text">
            {{
              text | invoiceTypeFilter
            }}
          </template>
          <template slot="invoiceCode" slot-scope="text,record">
            {{
              +record.invoiceType === 4 ? "--" : text
            }}
          </template>
          <template slot="invoiceAmountWithVat" slot-scope="text">
            {{
              text | splitK
            }}
          </template>
          <template slot="invoiceAmount" slot-scope="text">{{ text | splitK }}</template>
          <template slot="checkCode" slot-scope="text, record">{{ +record.invoiceType === 0 || +record.invoiceType === 1 ?
            "--" : text }}</template>
          <template slot="payableAmount" slot-scope="text">
            {{ text | splitK }}
          </template>

          <template slot="oper" slot-scope="text, record, index">
            <a-button type="link" v-if="record.file && record.file.errmsg" @click="handleDel(record, index)">删除</a-button>
            <a-button type="link" @click="handleEdit(record, index)">修改</a-button>
            <a-button type="link" v-if="record.id" @click="toInvInfo(record)">查看</a-button>
            <a-button type="link" v-if="record.id" @click="toRevoke(record, index)">撤销</a-button>
            <!-- <a @click="toInvInfo(record)">查看</a>
            <a @click="toRevoke(record, index)" class="text-color-orange">撤销</a>-->
          </template>
        </a-table>
        <div class="text-color-orange">温馨提示：请据实填写标的单据（发票）对应的应付金额，应付金额不可大于发票金额（含税）。</div>
      </div>
    </div>
    <div class="spaceCenter page-bottom-btns">
      <a-button class="btn-blue-line" @click="goBack()" style="margin:0 5px;">取消</a-button>
      <button-load @clickHandle="gotoCheck" type="primary" lable="去查验" />
    </div>

    <!-- 发票详情 -->
    <invoiceInfo ref="invoiceInfo" :info.sync="curRow" :readonly="readonly" :btns="btns" @success="getRowInfo" />
    <!-- 查验结果弹窗 -->
    <payableImportReslut ref="payableImportReslut" />
    <!-- 图片预览 -->
    <imgView ref="imgView" :src.sync="viewSrc" />
  </div>
</template>

<script>
import invoiceInfo from './invoice-info-dialog.vue'
import imgUpload from '@/components/ui/img-upload/img-upload'
import payableImportReslut from './payable-import-reslut.vue'
import invoiceUpload from '@/components/ui/invoiceUpload/index'
import {
  getQRCodeInfo,
  invoiceSave,
  updateById,
  invoiceList,
  invDelete,
  go2Check,
} from '@/api/payable.js'
import { fileSaveAPI } from '@/api/file.js'
import { mapActions } from 'vuex'
export default {
  components: { invoiceInfo, imgUpload, payableImportReslut, invoiceUpload },
  name: 'payable-import',
  data() {
    return {
      name: 'importFile',
      url: '/user/rcvbBuy/import',
      fileList: [],
      uploading: false,
      invoiceTypes: [],
      uploadParam: {
        app: 'portal-pc',
        module: 'payable',
        user: this.$store.getters['home/getUserHeader'].realname,
        tblBlId: this.utils.guid(32, 16),
        mdlId: 'payable',
      },
      pageData: {
        sellrName: this.$route.query.sellrName,
        sellrOrgCode: this.$route.query.sellrOrgCode,
        tenanId: this.$route.query.tenanId,
        docTpCd: '2',
        useCase: 'receivable',
      },
      tableData: [],
      curRow: null,
      loading: false,
      columns: [
        {
          title: '文件名称',
          dataIndex: 'fileNm',
          width: 120,
          scopedSlots: { customRender: 'fileNm' },
        },
        {
          title: '发票附件',
          dataIndex: 'fileRte',
          scopedSlots: { customRender: 'fileRte' },
        },
        {
          title: '识别结果',
          dataIndex: 'errmsg',
          width: 120,
          scopedSlots: { customRender: 'errmsg' },
        },
        {
          title: '发票类型',
          dataIndex: 'invoiceType',
          scopedSlots: { customRender: 'invoiceType' },
        },
        {
          title: '发票代码',
          dataIndex: 'invoiceCode',
          scopedSlots: { customRender: 'invoiceCode' },
        },
        {
          title: '发票号码',
          dataIndex: 'invoiceNumber',
        },
        {
          title: '开票日期',
          dataIndex: 'billTime',
        },
        {
          title: '发票金额（不含税）',
          dataIndex: 'invoiceAmount',
          scopedSlots: { customRender: 'invoiceAmount' },
        },
        {
          title: '验证码后六位',
          dataIndex: 'checkCode',
          scopedSlots: { customRender: 'checkCode' },
        },
        {
          title: '发票金额（含税）',
          dataIndex: 'invoiceAmountWithVat',
          scopedSlots: { customRender: 'invoiceAmountWithVat' },
        },
        {
          title: '应付金额',
          dataIndex: 'payableAmount',
          width: '120px',
          scopedSlots: { customRender: 'payableAmount' },
        },
        {
          title: '操作',
          dataIndex: 'oper',
          width: 180,
          scopedSlots: { customRender: 'oper' },
        },
      ],
      formDisabled: false,
      noRenderItem: ['tenanId', 'sellrName', 'sellrOrgCode'], //不能OCR识别覆盖的字段
      errList: [],
      readonly: false, //编辑/查看 开关
      btns: [],
      rowIndex: undefined,
      viewSrc: '',//图片预览地址
    }
  },
  created() {
    this.initPage()
    this.getDicAsync('InvoiceType').then((res) => {
      this.invoiceTypes = res
    })
  },
  methods: {
    ...mapActions({
      getDicAsync: 'app/getDicAsync',
    }),
    initPage() {
      this.pageData.sellrName = this.$route.query.sellrName
      this.pageData.sellrOrgCode = this.$route.query.sellrOrgCode
      this.pageData.tenanId = this.$route.query.tenanId
      this.getInvoiceList()
    },
    invTypeChange(val) {
      if (+val === 0 || +val === 1) {
        //专票
        this.ruleForm.checkCode = {}
        this.ruleForm.invoiceAmount = [
          {
            required: true,
            message: '发票金额（不含税）不能为空',
            trigger: 'blur',
          },
        ]
      } else if (+val === 2 || +val === 3) {
        this.ruleForm.invoiceAmount = {}
        this.ruleForm.checkCode = [
          {
            required: true,
            message: '发票校验码后六位不能为空',
            trigger: 'blur',
          },
        ]
      }
    },
    uploadOk(errobj) {
      if (errobj) {
        this.$set(errobj, 'payableAmount', errobj.payableAmount || errobj.invoiceAmountWithVat || 0)
        // this.errList.push(errobj)
        this.tableData.push(errobj)
      }
    },
    // 查询该卖方下未查验的单据列表
    getInvoiceList() {
      this.loading = true
      let param = {
        sellrOrgCode: this.pageData.sellrOrgCode,
        resultCode: 3,
        useCase: 'receivable',
      }
      invoiceList(param)
        .then((res) => {
          this.loading = false
          this.tableData = [...this.tableData, ...res.data.grid.list];
          this.tableData.forEach((i, index) => {
            this.$set(
              this.tableData[index],
              'payableAmount',
              i.payableAmount || i.invoiceAmountWithVat || 0
            )
          })
        })
        .catch((err) => {
          this.loading = false
        })
    },
    gotoCheck(btn) {
      let params = {
        cyCodeList: this.tableData.map((i) => i.cyCode),
      }
      if (this.tableData.length === 0) {
        this.$message.warning("发票列表为空，请先上传发票！");
        btn.closeLoad();
        return false
      }
      if (this.tableData.map((i) => i.id).includes(undefined)) {
        this.$message.warning("发票列表中存在识别失败的发票！");
        btn.closeLoad();
        return false
      }
      go2Check(params)
        .then((res) => {
          this.$message.success('操作成功')
          // this.goBack();
          this.$refs.payableImportReslut.open(res.data)
          btn.closeLoad()
        })
        .catch((err) => {
          btn.closeLoad()
        })
    },
    resetForm() {
      this.pageData = {
        sellrName: this.$route.query.sellrName,
        sellrOrgCode: this.$route.query.sellrOrgCode,
        tenanId: this.$route.query.tenanId,
      }
      this.fileList = null
      this.$refs.ruleForm.resetFields()
    },
    // 校验应付金额不能大于发票金额
    checkAmt(record) {
      if (record.payableAmount > record.invoiceAmountWithVat) {
        this.$message.error('应付金额不能大于发票金额（含税）')
        record.payableAmount = record.invoiceAmountWithVat
        return
      }
      if (record.payableAmount < 0) {
        this.$message.error('应付金额不能小于0')
        record.payableAmount = record.invoiceAmountWithVat
        return
      }
      record.canEstbGldBal = record.payableAmount
      updateById(record, true)
        .then((res) => {
          this.$message.success('应付金额更新成功')
        })
        .catch((err) => {
          btn && btn.closeLoad()
        })
    },
    // 查看发票信息
    toInvInfo(record) {
      this.btns = []
      this.curRow = record;
      this.readonly = true
      this.$refs.invoiceInfo.open()
    },
    toRevoke(record, index) {
      let self = this
      this.$confirm({
        title: '撤销',
        content: '是否撤销所勾选的应付账款？',
        onOk() {
          const params = {
            ids: record.id,
          }
          invDelete(params).then((res) => {
            self.$message.success('撤销成功')
            self.tableData.splice(index, 1)
          })
        },
        onCancel() { },
      })
    },
    handleDel(record, index) {
      let self = this
      this.$confirm({
        title: '删除',
        content: '是否删除所选的应付账款？',
        onOk() {
          self.tableData.splice(index, 1)
        },
        onCancel() { },
      })
    },
    handleEdit(record, index) {
      this.rowIndex = index
      this.btns = ['close', 'save2']
      this.curRow = {
        ...record,
        ...this.pageData,
        tblBlId: this.uploadParam.tblBlId,
      }
      this.readonly = false
      this.$refs.invoiceInfo.open()
    },
    getRowInfo(data) {
      this.$set(this.tableData, this.rowIndex, data)
    },
    goBack() {
      this.MENUAPI.goToOneTab({
        path: 'bill-manage/payable',
      })
    },
    getImgUrl(file) {
      if (file) {
        return (
          '/gb-bigtree-file/download/fileDownload/install' +
          file.fileRte +
          '/' +
          file.fileNm
        )
      }
    },
    preview(file) {
      if (file) {
        this.viewSrc = '/gb-bigtree-file/download/fileDownload/install' +
          file.fileRte +
          '/' +
          file.fileNm
        this.$refs.imgView.show();
      } else {
        this.$message.warning('文件不存在')
        return false
      }
    }
  },
  watch: {
    'pageData.invoiceType'(newVal) {
      this.invTypeChange(newVal)
    },
  },
}
</script>
<style scoped lang="less">
.ant-input-affix-wrapper /deep/ .ant-input:not(:last-child) {
  padding-right: 64px !important;
}

.file-item {
  background: #e5e7e8;
  line-height: 30px;
  height: 30px;
  padding: 0 10px;
  width: 240px;
  margin: 0 10px;
}

.img-tip {
  margin-top: -20px;
  white-space: nowrap;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/payable-import.vue